import React from "react";
import styled from "styled-components/macro";
import image from "../assets/images/bendystav-o-nas.jpeg";
const AboutUs = () => {
  return (
    <InfoContainer id="aboutus">
      <InfoWrapper>
        <TextWrapper>
          <Heading>O nás</Heading>
          <Subtitle>
            Firmy BendyStav byla založena v roce 2017 Jozefem Benčíkem, který má
            více než 30 leté zkušenosti v oboru pozemních a
            insfrastrukturálních. <br /> Za poměrně krátkou dobu se firma
            BendyStav dokázala prosadit ve velké konkurenci stavebních firem. V
            součastnosti provádí rekonstrukce nemovitostí, staví rodinné domy na
            klíč, vyrábí nábytek na míru a poskytuje úklidové služby.
          </Subtitle>
        </TextWrapper>
        <ImgWrap>
          <Img src={image} alt="Photo" />
        </ImgWrap>
      </InfoWrapper>
    </InfoContainer>
  );
};

export default AboutUs;

export const InfoContainer = styled.div`
  min-height: fit-content;
  padding: 5rem calc((100vw - 1300px) / 2);
  color: #fff;
`;

export const InfoWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 30%;
  justify-items: flex-start;
  padding: 0 2rem;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 440px;
`;

export const Heading = styled.h1`
  font-size: clamp(2rem, 5vw, 3rem);
  text-align: left;
  margin-bottom: 2rem;
  color: #000;
`;

export const Subtitle = styled.p`
  font-size: clamp(1rem, 2.5vw, 1.5rem);
  text-align: left;
  color: #000;
  font-weight: 300;
  margin-bottom: 1rem;
`;

export const ImgWrap = styled.div`
  max-width: 440px;
  height: 100%;
`;

export const Img = styled.img`
  width: 100%;
  border-radius: 10px;
`;
